export default "__VITE_ASSET__DxoErR25__"